import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { Objective, ObjectiveProgress, ObjectiveType } from 'src/app/models/objective.model';
import { ObjectiveService } from 'src/app/services/objective.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-progress-modal',
  templateUrl: './progress-modal.component.html',
  styleUrls: ['./progress-modal.component.scss'],
})
export class ProgressModalComponent  implements OnInit {

  @Input() objective!: Objective; // Objectif passé à la modal
  ObjectiveType = ObjectiveType

  progressForm: FormGroup;
  selectedRating?: number; // Pour stocker la note de 1 à 10
  quantifiableTypes = [
    ObjectiveType.Progressif,
    ObjectiveType.Degressif,
    ObjectiveType.Duree,
    ObjectiveType.Frequence,
  ];

  constructor(
    private modalCtrl: ModalController,
    private fb: FormBuilder,
    private objectiveService: ObjectiveService,
    private userService : UserService,
  ) { }

  ngOnInit() {
    this.progressForm = this.fb.group({
      progress: ['', [Validators.required]],
      note: [''],
      date: [new Date().toISOString(), [Validators.required]]
    });
  }


  submitProgress() {
    const isQuantifiable = this.quantifiableTypes.includes(this.objective.type);
    const progressValue = this.progressForm.value.progress;
  
    const formValid = isQuantifiable
      ? this.progressForm.valid
      : progressValue !== null && progressValue !== undefined;
  
    if (formValid) {
      const newProgress: ObjectiveProgress = {
        id: 0,
        objectiveId: this.objective.id,
        score: progressValue,
        note: this.progressForm.value.note,
        updatedById: this.userService.user.id,
        updatedAt: this.progressForm.value.date
      };
  
      this.objectiveService.addProgressUpdate(this.objective.id, newProgress).subscribe(() => {
        this.modalCtrl.dismiss(newProgress, 'success');
      });
    }
  }

  selectRating(rating: number) {
    this.selectedRating = rating;
    this.progressForm.patchValue({ progress: rating });
  }
  


  closeModal() {
    this.modalCtrl.dismiss(null, 'cancel');
  }

}
